import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DefaultLangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, Subject, Subscription } from 'rxjs';

import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
import { WertComponent } from '../../modals/wert/wert.component';
import { EventService } from '../../services/event.service';
import { PopupService } from '../../services/popup.service';
import { WalletConnectService } from '../../services/wallet-connect.service';
import { convertNum, SwapStatus } from '../../shared/constants/app-enums';
import { getChainData, getDynamicAmount, getNativeAmount, getUSDTAmount } from '../../shared/constants/wallet-connect.const';
import { IChainData } from '../../shared/interfaces/common.interface';
import { stakeData } from '../../shared/interfaces/wallet.interface';

@Component({
  selector: 'app-swap',
  templateUrl: './swap.component.html',
  styleUrls: ['./swap.component.scss'],
})
export class SwapComponent implements OnInit {
  @Input() isNative: boolean = false;
  @Input() isWert: boolean = false;
  @Input() isModal: boolean = false;
  @Output() messageEvent = new EventEmitter<boolean>();
  @ViewChild('swapIn') swapIn: ElementRef<HTMLInputElement> | null = null;
  @Input() swapMode: string = '';
  private subscriptions: Subscription[] = [];
  environtment = environment;
  baseToken?: number;
  swapToken?: number;
  swapTokenUpdate = new Subject<number | undefined>();
  baseTokenUpdate = new Subject<number | undefined>();
  currentLang?: string;
  SwapStatus = SwapStatus;
  lblockPrice = 0;
  isLowBalance = false;
  inProgress = false;

  isStake = false;
  usdtBal: number = 0;
  usdcBal: number = 0;
  nativeBal: number = 0;
  minAmount = environment.minToken;

  modalRef?: BsModalRef;
  lowGas = false;
  wertMode: boolean = false;

  chainData!: IChainData;
  modeName: string = '';
  walletAddress: string = '';
  status!: SwapStatus;
  hash!: string;
  tokenName: string = '';
  gasFees!: number;
  maxTokensToBuy?: number;
  cryptoName = environment.tokenName;
  stakeData!: stakeData;
  allBalance: { native: number; usdt: number; usdc: number } = { native: 0, usdt: 0, usdc: 0 };

  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private walletConnectService: WalletConnectService,
    private eventService: EventService,
    private modalService: BsModalService,
    private translate: TranslateService,
    private popupService: PopupService,
    private router: Router,
  ) {
    this.currentLang = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: DefaultLangChangeEvent) => {
      this.currentLang = params.lang || 'en';
    });

    this.eventService.getNetwork().subscribe((val) => {
      this.getBal();
      if (!this.isWert) this.max();
    });

    //to check the value of swap
    this.subscriptions.push(
      this.swapTokenUpdate.pipe(debounceTime(500)).subscribe((value) => {
        if (this.swapToken && this.swapToken >= 0) {
          this.calculateSwap();
        } else {
          this.baseToken = 0;
        }
      }),
    );
    this.subscriptions.push(
      this.baseTokenUpdate.pipe(debounceTime(500)).subscribe((value) => {
        if (this.baseToken && this.baseToken >= 0) {
          this.calculateSwapReverse();
        } else {
          this.swapToken = 0;
        }
      }),
    );

    if (isPlatformBrowser(this._platformId)) setInterval(() => this.updateAllgetMethod(), 500);
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.swapToken = undefined;
      this.baseToken = undefined;
      this.walletConnectService.swapStatus = SwapStatus.not_started;
      this.isLowBalance = false;
      this.lowGas = false;
      this.getBal();
      this.checkLowBalance();
      this.updateAllgetMethod();
      if (!this.isWert) this.max();
    }, 600);
  }

  updateAllgetMethod(): void {
    this.chainData = getChainData(this.walletConnectService.chainId) as IChainData;
    this.modeName = this.chainData.purchaseToken;
    this.walletAddress = this.walletConnectService.walletAddress;
    this.status = this.walletConnectService.swapStatus;
    this.hash = this.walletConnectService.swapHash;
    this.tokenName = this.isNative ? this.modeName : this.isWert ? 'USD' : this.swapMode === 'usdt' ? 'USDT' : 'USDC';
    this.gasFees = this.modeName === 'ETH' ? environment.eth.gasFees : environment.bsc.gasFees;
    this.maxTokensToBuy = this.walletConnectService.balanceData.maxTokensToBuy;
    this.cryptoName = environment.tokenName;
    this.stakeData = this.walletConnectService.stakeData;
    this.allBalance = {
      native: +this.walletConnectService.balanceData.nativeBal.toFixed(10).replace(/0{0,10}$/, ''),
      usdt: this.walletConnectService.balanceData.usdtBal,
      usdc: this.walletConnectService.balanceData.usdcBal,
    };
    this.getBal();
  }

  ngOnInit(): void {
    this.walletConnectService.swapStatus = SwapStatus.complete;
    this.isLowBalance = false;
  }

  async max() {
    let maxVal = this.isNative
      ? await getDynamicAmount(this.maxTokensToBuy! * 1.01, 'getNativeAmount', this.chainData.chainIdInt, this.walletConnectService.balanceData)
      : await getDynamicAmount(this.maxTokensToBuy!, 'getUSDTAmount', this.chainData?.chainIdInt, this.walletConnectService.balanceData);
    this.swapToken = +this.floorString((this.isNative ? (this.nativeBal - this.gasFees > 0 ? this.nativeBal - this.gasFees : 0) : this.swapMode === 'usdc' ? this.usdcBal : this.usdtBal).toString());
    if (maxVal < this.swapToken) {
      this.swapToken = maxVal;
    }
    if (this.swapToken == 0) {
      this.swapToken = undefined;
      this.baseToken = 0;
    }
    this.swapTokenUpdate.next(this.swapToken);
    if (this.isWert) this.swapToken = undefined;

    setTimeout(() => this.swapTokenUpdate.next(this.swapToken), 200);
  }

  getBal() {
    this.nativeBal = this.allBalance.native;
    this.usdtBal = this.allBalance.usdt;
    this.usdcBal = this.allBalance.usdc;
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  startAgain(): void {
    this.getBal();
    this.max();
    this.walletConnectService.swapStatus = SwapStatus.not_started;
  }

  confirm(isBuyStake: boolean = false) {
    this.isStake = isBuyStake;

    if (this.checkChain()) {
      if (this.isWert) {
        this.modalRef = this.modalService.show(WertComponent, {
          class: 'modal-xs modal-dialog-centered transak',
          backdrop: 'static',
          initialState: {
            walletAddress: this.walletAddress,
            baseToken: this.baseToken,
            swapToken: this.swapToken,
            isStake: this.isStake,
          },
        });
      } else {
        if (this.swapToken !== 0 && this.baseToken && this.baseToken >= this.minAmount) this.createSwap(isBuyStake);
      }
    }
  }

  calculateSwap = async () => {
    this.checkLowBalance();
    if (this.isNative) {
      this.baseToken = await getNativeAmount((this.swapToken ?? 0) * 0.99, this.chainData.chainIdInt, this.walletConnectService.balanceData);
    } else {
      this.baseToken = await getUSDTAmount(this.swapToken ?? 0, this.chainData.chainIdInt, this.walletConnectService.balanceData);
    }
    this.baseToken = +this.baseToken.toFixed(0).replace(/0{0,0}$/, '');
    // console.log("calculateSwap here", this.isNative, this.swapToken, this.baseToken);
  };

  calculateSwapReverse = async () => {
    if (this.isNative) {
      this.swapToken = await getDynamicAmount(this.baseToken ?? 0, 'getNativeAmount', this.chainData.chainIdInt, this.walletConnectService.balanceData);
      this.swapToken = +(this.swapToken * 1.001).toFixed(10).replace(/0{0,10}$/, '');
      console.log(this.swapToken);
    } else {
      this.swapToken = await getDynamicAmount(this.baseToken ?? 0, 'getUSDTAmount', this.chainData.chainIdInt, this.walletConnectService.balanceData);
    }
    this.checkLowBalance();
    // console.log("calculateSwapReverse here", this.swapToken, this.baseToken);
  };

  async createSwap(isBuyStake: boolean = false) {
    if (this.inProgress) return;
    this.inProgress = true;
    console.log('createSwap called', this.isNative, this.maxTokensToBuy);
    if (this.baseToken && this.baseToken <= this.maxTokensToBuy!) {
      this.walletConnectService.swapStatus = SwapStatus.not_started;
      try {
        if (this.isNative) {
          if (this.nativeBal - this.gasFees >= (this.swapToken ?? 0)) {
            this.isLowBalance = false;
            await this.walletConnectService.swapNativeTokens(this.baseToken, this.swapToken ?? 0, isBuyStake);
          } else {
            this.isLowBalance = true;
          }
        } else {
          if (this.swapMode === 'usdt') {
            if (this.usdtBal >= (this.swapToken ?? 0) && this.nativeBal >= this.gasFees) {
              this.isLowBalance = false;
              await this.walletConnectService.swapCryptoForUSDT(this.baseToken, this.swapToken ?? 0, false, isBuyStake, false);
            } else {
              this.isLowBalance = true;
              if (this.nativeBal < this.gasFees) this.lowGas = true;
            }
          } else {
            if (this.usdcBal >= (this.swapToken ?? 0) && this.nativeBal >= this.gasFees) {
              this.isLowBalance = false;
              await this.walletConnectService.swapCryptoForUSDT(this.baseToken, this.swapToken ?? 0, false, isBuyStake, true);
            } else {
              this.isLowBalance = true;
              if (this.nativeBal < this.gasFees) this.lowGas = true;
            }
          }
        }
        this.inProgress = false;
      } catch (err: any) {
        console.log('createSwap', err);
        if (err && err.code == 4001) {
          this.walletConnectService.swapStatus = SwapStatus.rejected;
        } else {
          this.walletConnectService.swapStatus = SwapStatus.failed;
        }
        this.inProgress = false;
      }
    } else {
      this.popupService.messagePopup({
        icon: 'warning',
        title: this.translate.instant('widget.max_token_title'),
        desc: this.translate.instant('widget.max_token_exceed', {
          maxTokensToBuy: this.maxTokensToBuy,
        }),
        confirmBtnTxt: this.translate.instant('misc.ok'),
      });
      this.walletConnectService.swapStatus = SwapStatus.not_started;
      this.inProgress = false;
    }
  }

  viewUrl() {
    const blkUrl = this.chainData.blockExplorerURL;
    window.open(blkUrl + this.hash, '_blank');
  }

  checkLowBalance(): void {
    if (this.isNative) {
      // check low balance for Native tokens like ETH or BNB
      if (this.nativeBal - this.gasFees >= (this.swapToken ?? 0)) {
        this.isLowBalance = false;
      } else {
        this.isLowBalance = true;
      }
    } else if (this.swapMode === 'usdt') {
      // check low balance for USDT
      if (+this.usdtBal >= (this.swapToken ?? 0) && +this.nativeBal >= this.gasFees) {
        this.isLowBalance = false;
        this.lowGas = false;
      } else {
        this.isLowBalance = true;
        if (this.nativeBal < this.gasFees) this.lowGas = true;
      }
    } else {
      // check low balance for USDC
      if (+this.usdcBal >= (this.swapToken ?? 0) && +this.nativeBal >= this.gasFees) {
        this.isLowBalance = false;
        this.lowGas = false;
      } else {
        this.isLowBalance = true;
        if (this.nativeBal < this.gasFees) this.lowGas = true;
      }
    }
  }

  openWert(): void {
    this.eventService.broadcastEvent('OPEN_WERT', true);
  }

  checkChain(): boolean {
    if (this.walletConnectService.chainId == this.chainData.chainIdInt) {
      return true;
    } else {
      if (this.walletConnectService.mode == 'wallet') {
        this.walletConnectService.switchNetwork(this.chainData.chainIdInt).then(() => {
          return true;
        });
        return true;
      } else {
        this.popupService
          .messagePopup({
            icon: 'info',
            title: this.translate.instant('popup.change_network'),
            desc: this.translate.instant('popup.wrong_chain', {
              chainName: environment.eth.chainName,
            }),
            confirmBtnTxt: this.translate.instant('misc.ok'),
          })
          .subscribe({
            next: (res: boolean) => {
              if (res) {
                this.walletConnectService.switchNetwork(this.chainData.chainIdInt);
              }
            },
          });
        return false;
      }
    }
  }

  convertNum(amount: number, decimals: number = 2) {
    return convertNum(amount, decimals);
  }

  floorString(str: string) {
    let pos = str.indexOf('.');
    return pos >= 0 ? (str + '00').slice(0, pos + 6) : str + '.00';
  }

  changeChain(mode: string): void {
    if (mode == this.modeName) return;
    let chain = mode == 'ETH' ? environment.eth : environment.bsc;

    if (this.modeName == 'ETH') {
      this.popupService
        .messagePopup({
          icon: 'info',
          title: this.translate.instant('popup.are_you_sure'),
          desc: this.translate.instant('popup.change_swap_text', {
            apy: this.stakeData?.apy,
            mode: mode,
          }),
          confirmBtnTxt: this.translate.instant('popup.buy_with_mode', { mode: mode }),
          cancelBtnTxt: this.translate.instant('misc.cancel'),
        })
        .subscribe({
          next: (result: boolean) => {
            /* Read more about isConfirmed, isDenied below */
            if (result) {
              if (this.walletAddress) {
                this.walletConnectService.switchNetwork(chain.chainIdInt);
                this.calculateSwap();
              } else {
                this.walletConnectService.chainId = chain.chainIdInt;
                this.calculateSwap();
              }
            }
          },
        });
    } else {
      if (this.walletAddress) {
        this.walletConnectService.switchNetwork(chain.chainIdInt);
        this.calculateSwap();
      } else {
        this.walletConnectService.chainId = chain.chainIdInt;
        this.calculateSwap();
      }
    }
  }

  changeTab(isNative: boolean = true, swapMode: string): void {
    this.isNative = isNative;
    this.swapMode = swapMode;
    this.messageEvent.emit(false);
    setTimeout(() => this.max(), 1000);
  }

  cardMode(): void {
    this.swapToken = 0;
    this.baseToken = 0;
    this.isNative = false;
    this.swapMode = 'card';
    this.messageEvent.emit(true);
  }

  stakeNow(): void {
    this.walletConnectService.switchNetwork(environment.eth.chainIdInt);
    this.router.navigateByUrl(this.currentLang + '/staking', {});
  }
}
